import React from 'react';
import { Link } from 'react-router-dom';
import { SmartBlock, SmartSpace, SmartButton } from '../../SmartComponent';
import { useTranslation } from 'react-i18next';


export default function Prepack(): JSX.Element {
  const { t } = useTranslation()
  return (
    <SmartBlock>
      <SmartSpace>
        <Link to="/smart/pack/adjust">
          <SmartButton>
            {t('smart.prepack.pack.adjust.title')}
          </SmartButton>
        </Link>
      </SmartSpace>
    </SmartBlock>
  );
}
